export default __webpack_public_path__ + "graphics/jcb.4d7f9871.jpg";